export default __webpack_public_path__ + "static/media/shareTunes3Low.b25d3658.png";